import { ENV } from "../utils";

export class Productionform {
  baseApi = ENV.BASE_API;

  async getProductionForm(accessToken, idProductionForm) {
    try {
      const url = `${this.baseApi}/production/${idProductionForm}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async createProductionForm(accessToken, data) {
    try {
      // const formData = new FormData();
      // Object.keys(data).forEach((key) => {
      //   formData.append(key, data[key]);
      // });
      // const url = `${this.baseApi}/${ENV.API_ROUTES.USER}`;
      const url = `${this.baseApi}/add-production`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async getProductionForms(accessToken, paramsProduction, active = undefined) {
    try {
      const pageFilter = `page=${paramsProduction?.page || 1}`;
      const limitFilter = `limit=${paramsProduction?.limit || 10}`;
      const siteFilter = `site=${paramsProduction?.site || undefined}`;
      // const url = `${this.baseApi}/${ENV.API_ROUTES.USERS}?active=${active}`;
      let url = `${this.baseApi}/productions?${pageFilter}&${limitFilter}`;
      if (active !== undefined) {
        url = `${this.baseApi}/productions?active=${active}&${pageFilter}&${limitFilter}`;
      }
      if (paramsProduction?.site) {
        url = `${url}&${siteFilter}`;
      }
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateProductionForm(
    accessToken,
    idProductionForm,
    productionformData
  ) {
    try {
      const data = productionformData;

      // const formData = new FormData();
      // Object.keys(data).forEach((key) => {
      //   formData.append(key, data[key]);
      // });

      // const url = `${ENV.BASE_API}/${ENV.API_ROUTES.USER}/${idUser}`;
      const url = `${ENV.BASE_API}/update-production/${idProductionForm}`;
      const params = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteProductionForm(accessToken, idProductionForm) {
    try {
      // const url = `${this.baseApi}/${ENV.API_ROUTES.USER}/${idUser}`;
      const url = `${this.baseApi}/delete-production/${idProductionForm}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async existsProductionFormByPeriodAndYear(accessToken, siteId, period, year) {
    try {
      const url = `${this.baseApi}/production-exists-site/${siteId}/${period}/${year}`;

      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async getPeriodsProductionFormsBySiteAndYear(accessToken, siteId, year) {
    try {
      const url = `${this.baseApi}/productions-periods-site-year/${siteId}/${year}`;

      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async getProductionFormsBySiteAndYear(accessToken, siteId, year) {
    try {
      const url = `${this.baseApi}/productions-site-year/${siteId}/${year}`;

      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

    async getProductionFormsBySiteAndYears(accessToken, siteId, years) {
    try {
      const url = `${this.baseApi}/productions-site-years/${siteId}`;

      const params = {
             method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({years:years}),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async uploadFileApi(accessToken, data) {
    const url = `${this.baseApi}/upload-file-production/`;

    const params = {
      method: "POST",
      body: data,
      headers: {
        //'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${accessToken}`,
      },
    };
    return fetch(url, params)
      .then((response) => {
        
        return response.json();
      })
      .then((result) => {
        return result;
      })
      .catch((err) => {
        return err.message;
      });
  }

  getFileApi(fileName) {
    const url = `${this.baseApi}/get-file-production/${fileName}`;
    return url;
  }

  async deleteFileApi(accessToken, fileName) {
    const url = `${this.baseApi}/delete-file-production`;

    const params = {
      method: "DELETE",
      body: JSON.stringify({ fileName }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    };
    return fetch(url, params)
      .then((response) => {
        return response.url;
      })
      .catch((err) => {
        return err.message;
      });
  }

  async getTotalBaselineByYearAndSite(accessToken, siteId, year, baseline) {
    try {
      const url = `${this.baseApi}/production-baseline-total-site-year/${siteId}/${year}/${baseline}`;

      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async getLastUnitFieldsByYear(accessToken, siteId, year, data) {
    try {
      const url = `${this.baseApi}/last-unit-fields-production/${siteId}/${year}`;
      
      const params = {
        method: "POST",
        body: JSON.stringify({fields:data}),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateProductionField(accessToken, siteId, data) {
    try {
      const url = `${this.baseApi}/update-productions-field/${siteId}`;

      const params = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async batchUpdateProductionForms(accessToken, data) {
    const url = `${this.baseApi}/production-forms/batch-update`;
    const params = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(data),
    };
    const response = await fetch(url, params);
    return await response.json();
  }
}
